import styled from "@emotion/styled";
import { Typography, Grid, Divider } from "@mui/material";
import { forwardRef } from "react";

const SectionDivider = styled(Divider)({
  backgroundColor: "black",
});

const PageFooter = forwardRef(({ pageNumber }, ref) => {
  return (
    <Grid container direction="column" ref={ref}>
      <SectionDivider />
      <Grid container direction="row" paddingRight={2}>
        <Grid item xs container justifyContent="center">
          <Typography variant="caption" textAlign="center">
            Please refer page 2 for "How to respond to an ad" |{" "}
            <span style={{ fontSize: 10 }}>
              දැන්වීමකට ප්‍රතිචාර දක්වන ආකාරය දැනගැනීම සඳහා පිටු අංක 2 බලන්න
            </span>
          </Typography>
        </Grid>
        <Typography variant="caption">{pageNumber}</Typography>
      </Grid>
    </Grid>
  );
});

export default PageFooter;
